/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { SpecialityModule } from '@ecsper/speciality-contract';
import { specialityId } from '@ecsper/speciality-contract';

import { expertWitnessCitationTypes } from './citation-types.js';
import { expertWitnessComplianceFrameworks } from './compliance.js';
import { expertWitnessContentControlSchemas } from './content-controls.js';
import { expertWitnessParagraphTypes } from './paragraph-types.js';
import { expertWitnessTemplates } from './templates.js';
import { expertWitnessValidationRules } from './validation-rules.js';
import { expertWitnessWordRibbon } from './word/ribbon.js';
import { ExpertWitnessTaskPane } from './word/TaskPane.js';

export const ExpertWitnessModule: SpecialityModule = {
  id: specialityId('expert-witness'),
  displayName: { 'en-GB': 'Expert Witness' },
  description: {
    'en-GB': 'CPR Part 35-compliant expert witness reporting for legal disputes in England & Wales',
  },
  version: '0.1.0',

  sectors: ['legal'],
  jurisdictions: ['EW'],

  hosts: {
    word: {
      taskPane: ExpertWitnessTaskPane,
      ribbon: [...expertWitnessWordRibbon],
    },
  },

  paragraphTypes: expertWitnessParagraphTypes,
  citationTypes: expertWitnessCitationTypes,
  contentControlSchemas: expertWitnessContentControlSchemas,
  templates: expertWitnessTemplates,
  complianceFrameworks: expertWitnessComplianceFrameworks,
  validationRules: expertWitnessValidationRules,

  entitlementKey: 'plugin.expert-witness',
};
